import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { TableModule } from 'primeng/table';
import { CoreModule } from '@app/core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { TabViewModule } from 'primeng/tabview';
import { SliderModule } from 'primeng/slider';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CalendarModule } from "primeng/calendar";
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule, NgbModule,
    DashboardRoutingModule,
    TableModule,
    CoreModule,
    FormsModule,
    TranslateModule,
    TabViewModule,
    SliderModule,
    SharedModule,
    CalendarModule
  ],
  declarations: [DashboardComponent]
})
export class DashboardModule { }
